import React, { Fragment } from "react";
import { withStyles, Grid } from "@material-ui/core";
import { Route } from "react-router-dom";
import styles from "./NewRouterStyles";

class WebsiteRouter extends React.Component<any, any> {
  render() {
    const { classes, language, path, component: Comp } = this.props;
    return (
      <Grid container className={classes.mainContainer}>
        <Grid item xs={12} className={classes.contentContainer}>
          <Route
            path={path}
            exact
            render={({ history, location, match }) => (
              <Comp
                language={language}
                history={history}
                location={location}
                match={match}
              />
            )}
          />
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(WebsiteRouter);
